export const toPrettyCurrency = (number?: Number, { dashForZero = true } = {}) =>
  number ? number.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : dashForZero ? '-' : number;
